import { render, staticRenderFns } from "./ThreadPost.vue?vue&type=template&id=cbd0de20&scoped=true"
import script from "./ThreadPost.vue?vue&type=script&lang=js"
export * from "./ThreadPost.vue?vue&type=script&lang=js"
import style0 from "./ThreadPost.vue?vue&type=style&index=0&id=cbd0de20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd0de20",
  null
  
)

export default component.exports